import * as ShareableLinkApi from '../../apis/shareableLink';
import * as ShareableLinkSelectors from '../../selectors/shareableLink';
import * as ShareableLinkActionTypes from '../../types/shareableLink';
import * as GroupsActions from '../groups';
import * as CurrentsSelctors from '../../selectors/current';
import * as CurrentsActions from '../current';
import * as GroupsSelectors from '../../selectors/groups';
import * as groupTypes from '../groups/groupTypes';

export const generateLink = () => async(dispatch, getState) => {
    const shareableLink = ShareableLinkSelectors.getLink(getState());
    let result;

    if (shareableLink) {
        result = shareableLink;
    } else {
        const currentCollaboratorId = CurrentsSelctors.getCurrentCollaboratorId(getState());

        result = await dispatch(createShareableLink(currentCollaboratorId));
    }

    const groupId = GroupsSelectors.getGroupIdByType(getState(), groupTypes.COLLABORATORS);
    dispatch(CurrentsActions.setCurrentGroupIdAndCurrentCollaboratorId(groupId));
    return result;
};

export const setShareableLinks = (links) => {
    if (!links || !Object.values(links).length) {
        return { type: ShareableLinkActionTypes.SET_SHAREABLE_LINK, link: null };
    }

    return ({
        type: ShareableLinkActionTypes.SET_SHAREABLE_LINK,
        link: Object.values(links)[0]
    });
};

export const setLinkStatus = (status) => (dispatch, getState) => {
    const oldStatus = ShareableLinkSelectors.getLinkStatus(getState());

    dispatch({
        type: ShareableLinkActionTypes.SET_STATUS,
        status
    });

    return Promise.resolve()
        .then(() => ShareableLinkSelectors.getLinkId(getState()))
        .then((linkId) => ShareableLinkApi.setLinkStatus(linkId, status))
        .catch((error) => {
            dispatch({
                type: ShareableLinkActionTypes.SET_STATUS,
                status: oldStatus
            });
            throw error;
        });
};

const createShareableLink = (currentCollaboratorId) => (dispatch) => Promise.resolve()
    .then(() => dispatch({ type: ShareableLinkActionTypes.FETCH_START }))
    .then(
        () => dispatch(GroupsActions.getOrCreateCollaborationGroupId())
    ).then(
        (collaborationGroupId) => ShareableLinkApi.generateLink(collaborationGroupId, currentCollaboratorId)
    ).then((link) => {
        dispatch({
            type: ShareableLinkActionTypes.FETCH_SUCCESS,
            link
        });

        return link;
    }).catch((err) => {
        dispatch({ type: ShareableLinkActionTypes.FETCH_FAILURE, error: err });
    });
